import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Col, Container, Row } from "react-grid-system";
import { FcSearch } from "react-icons/fc";

import colors from "../assets/colors/colors";

import Header from "../components/Restaurant/Header";
import ListCategories from "../components/Restaurant/ListCategories";
import Filters from "../components/Restaurant/Filters";

import { StyledColorBackground } from "../interface/index";

import Loader from "../components/utils/Loader";
import ModalQRCode from "../components/Restaurant/admin/ModalQRCode";
import ViewOrderPreview from "../components/Restaurant/order/ViewOrderPreview";
import ViewOrderComplete from "../components/Restaurant/order/ViewOrderComplete";

import mainStore from "../store/index";

import PromoDR from "../components/Advertisements/PromoDR";
import FixedContact from "../components/Restaurant/FixedContact";
import FilterByCategory from "../components/Restaurant/FilterByCategory";
import PostsCategories from "../components/Restaurant/PostsCategories";

import { getDatabase, ref, onValue } from "firebase/database";

export default function MenuId(props: any) {
  const STORE = mainStore();
  let params = useParams();
  let { id }: any = useParams();

  const [DataMenu, setDataMenu] = useState<any>(null);
  const [loader, setLoader] = useState(true);

  const [dataSections, setDataSections] = useState<any>([]);
  const [badgeSelect, setBadgeSelect] = useState<any>(null);
  const [textCopy, setTextCopy] = useState<string>("");
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [openOrderComplete, setOpenOrderComplete] = useState<boolean>(false);

  const [selected, setSelected] = useState<number>(0);

  const [personalize, setPersonalize] = useState<any>(null);

  const primitivoUI = {
    colors1: "#963021",
    colors2: "#b8331e",
    colors3: "#191010",
  };

  const naPopiUI = {
    colors1: "#AA4966",
    colors2: "#AA4966",
    colors3: "#AA4966",
  };

  const theFactoryBurger = {
    colors1: "#b3211f",
    colors2: "#b3211f",
    colors3: "#b3211f",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    switch (params.id) {
      case "PhpB4BRwJNbjXsMIoeeuqhhUjCQ2":
        setPersonalize(primitivoUI);
        break;
      case "NkkeUIZe4KOJx8erDUjzqLYlgto2":
        setPersonalize(naPopiUI);
        break;
      case "uQyOouQ5GAS27NNclmo0jZ0xCQy2":
        setPersonalize(theFactoryBurger);
        break;
      default:
        setPersonalize(null);
        break;
    }

    if (params.id !== null) {
      getData(params.id);
    }
  }, []);

  const getData = async (ID: any) => {
    setLoader(true);

    let data;
    const realtime = getDatabase();
    const starCountRef = ref(realtime, "restaurants/" + id);
    onValue(starCountRef, (snapshot) => {
      if (snapshot.exists()) {
        data = snapshot.val();

        setDataMenu(data);
        getDataSections(data.menu);
      } else {
      }
    });
  };

  const getDataSections = async (menu: any) => {
    setLoader(true);
    const newArray: any = [];
    let itemsCrudo: any = [];

    if (!menu) {
      setLoader(false);
      return;
    }

    Object.entries(menu).forEach(([key, value]: any) => {
      newArray.push(value);
      itemsCrudo.push(value.items);
    });

    newArray.sort((a: any, b: any) => a.position - b.position);
    let arrayItems: any = [];

    Object.entries(itemsCrudo).forEach(([key, value]: any) => {
      if (value !== undefined) {
        arrayItems.push(value);
      }
    });

    let newItem2: any = [];
    arrayItems.map((data: any) => {
      Object.entries(data).forEach(([key, value]: any) => {
        newItem2.push(value);
      });
    });

    setDataSections(newItem2);

    setLoader(false);

    setDataSections(newArray);
  };

  const copyLink = () => {
    navigator.clipboard.writeText(textCopy);
    toast.success("Menu copiado. Puedes compartirlo con tus amigos🥳🤗");
  };

  const handleOpenFilter = () => {
    let open = !openFilter;
    setOpenFilter(open);
  };

  const handleOperOrderComplete = () => {
    let open = !openOrderComplete;
    setOpenOrderComplete(open);
  };

  const selectedSection = (data: any) => {
    if (data) {
      const idSection = data.id;
      const idRestaurant = data.id_restaurant;
      setBadgeSelect(idSection);
    } else {
      setBadgeSelect(null);
    }
  };

  return (
    <>
      {loader ? (
        <LoaderContent>
          <Loader color={personalize ? personalize.colors2 : "#3498db"} />
          <>
            <div style={{ padding: "1em 0" }}>
              <h4>Cargando menú digital...</h4>
            </div>
          </>
        </LoaderContent>
      ) : (
        <ContentRestaurant color={colors} background={""}>
          {DataMenu && <Header data={DataMenu} colors={personalize} />}
          {DataMenu && (
            <main>
              <>
                <Container>
                  <div className="pt-3">
                    <FilterByCategory
                      selectedSection={selectedSection}
                      badgeSelect={badgeSelect}
                      dataSections={dataSections}
                      colors={personalize}
                    />
                  </div>
                  <div className="pt-2">
                    <Row align="center" justify="center">
                      <Col>
                        <h2 style={{ color: "#2c3e50" }}>
                          <b>Menú</b>
                        </h2>
                      </Col>
                      <Col></Col>
                    </Row>
                  </div>
                </Container>
                <>
                  {dataSections && (
                    <>
                      {openFilter && (
                        <Filters
                          closeFilter={handleOpenFilter}
                          data={dataSections}
                        />
                      )}
                      {dataSections.map((section: any, index: any) => (
                        <>
                          {badgeSelect ? (
                            <>
                              {badgeSelect === section.id && (
                                <>
                                  {selected === 0 && (
                                    <ListCategories
                                      key={index}
                                      menu={section}
                                      colors={personalize}
                                      id_restaurant={params.id}
                                    />
                                  )}
                                  {selected === 1 && (
                                    <PostsCategories
                                      key={index}
                                      menu={section}
                                      colors={personalize}
                                      id_restaurant={params.id}
                                    />
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {selected === 0 && (
                                <ListCategories
                                  key={index}
                                  menu={section}
                                  id_restaurant={params.id}
                                  colors={personalize}
                                />
                              )}
                              {selected === 1 && (
                                <PostsCategories
                                  key={index}
                                  menu={section}
                                  colors={personalize}
                                  id_restaurant={params.id}
                                />
                              )}
                            </>
                          )}
                        </>
                      ))}
                    </>
                  )}
                </>
                <Container>
                  <div className="mt-5 text-center">
                    <button
                      className="btn btn-primary mb-4"
                      onClick={() => copyLink()}
                    >
                      Compartir menú🔗
                    </button>
                    {DataMenu && (
                      <ModalQRCode
                        link={`https://menudr.netlify.app/menu/${DataMenu.id}`}
                        openModalQR={() => ""}
                      />
                    )}
                  </div>
                </Container>
                <PromoDR />
              </>
            </main>
          )}
          <ViewOrderPreview
            data={STORE.order_user}
            handleOrderComplete={handleOperOrderComplete}
          />
          {openOrderComplete && <ViewOrderComplete />}
          <Toaster position="bottom-center" reverseOrder={false} />
        </ContentRestaurant>
      )}
    </>
  );
}

const LoaderContent = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const ContentRestaurant = styled.div<StyledColorBackground>`
  background-size: contain;
  main {
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;

    h3,
    h4 {
      font-weight: 500;
      color: ${(props) => props.color.black};
    }
    .inp {
      width: 100%;
      display: block !important;
      font-size: 1em !important;
      border-bottom: 2px solid #ecf0f1 !important;
      border-radius: none !important;
      border: 2px solid rgba(0, 0, 0, 0.13) !important;
    }
    .badge {
      font-size: 1.1em;
      transition: all 0.6s;
    }
  }
`;
